import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import Slide from "@/models/WebsiteWidget/PhotoSlider/Slide/Slide";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";
import orderBy from 'lodash/orderBy';

export default class PhotoSlider extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/photo-slider';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetPhotoSliders';

    static model_name = 'PhotoSlider';

    static fields() {
		return {
			id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
            slides: this.hasMany(Slide, 'website_widget_photo_slider_id'),
		}
	}

    /**
     *
     * @constructor
     */
    Slides() {
        return orderBy(this.getRelated('slides'), 'rank');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
